export const DIRS_USER_ACCESS_PREFIX = '@DIRS/USER_ACCESS';
export const DIRS_USER_BLOCKED_PREFIX = '@DIRS/USER_BLOCKED';
export const DIRS_GROUP_ACCESS_PREFIX = '@DIRS/GROUP_ACCESS';
